// extracted by mini-css-extract-plugin
export default {"container":"Answer_container__wWPA8","textLocation__legendStyle":"Answer_textLocation__legendStyle__oVF29","textLocation__buttonStyle":"Answer_textLocation__buttonStyle__AsFOc"};